module.exports = __webpack_public_path__ + "static/media/navigate.3eda36db.svg";